/**
 * @deprecated will be removed or significantly changed in future versions
 */
export interface ISingleShadow {
    color: string;
    x: string;
    y: string;
    blur: string;
    spread: string;
}

/**
 * @deprecated will be removed or significantly changed in future versions
 */
export interface IShadows {
    "shadow-x-small-default": ISingleShadow[];
    "shadow-x-small-secondary": ISingleShadow[];
    "shadow-x-small-tertiary": ISingleShadow[];
    "shadow-x-small-success": ISingleShadow[];
    "shadow-x-small-error": ISingleShadow[];
    "shadow-x-small-focused-default": ISingleShadow[];
    "shadow-x-small-focused-secondary": ISingleShadow[];
    "shadow-x-small-focused-tertiary": ISingleShadow[];
    "shadow-x-small-focused-success": ISingleShadow[];
    "shadow-x-small-focused-error": ISingleShadow[];
    "shadow-small-default": ISingleShadow[];
    "shadow-small-secondary": ISingleShadow[];
    "shadow-small-tertiary": ISingleShadow[];
    "shadow-small-success": ISingleShadow[];
    "shadow-small-error": ISingleShadow[];
    "shadow-regular-default": ISingleShadow[];
    "shadow-regular-secondary": ISingleShadow[];
    "shadow-regular-tertiary": ISingleShadow[];
    "shadow-regular-success": ISingleShadow[];
    "shadow-regular-error": ISingleShadow[];
    "shadow-medium-default": ISingleShadow[];
    "shadow-medium-secondary": ISingleShadow[];
    "shadow-medium-tertiary": ISingleShadow[];
    "shadow-medium-success": ISingleShadow[];
    "shadow-medium-error": ISingleShadow[];
    "shadow-large-default": ISingleShadow[];
    "shadow-large-secondary": ISingleShadow[];
    "shadow-large-tertiary": ISingleShadow[];
    "shadow-large-success": ISingleShadow[];
    "shadow-large-error": ISingleShadow[];
    "shadow-x-large-default": ISingleShadow[];
    "shadow-x-large-secondary": ISingleShadow[];
    "shadow-x-large-tertiary": ISingleShadow[];
    "shadow-x-large-success": ISingleShadow[];
    "shadow-x-large-error": ISingleShadow[];
    "shadow-xx-large-default": ISingleShadow[];
    "shadow-xx-large-secondary": ISingleShadow[];
    "shadow-xx-large-tertiary": ISingleShadow[];
    "shadow-xx-large-success": ISingleShadow[];
    "shadow-xx-large-error": ISingleShadow[];
}
